import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import { setAutoFreeze } from 'immer';
import storage from 'redux-persist/lib/storage';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import LocationAPI from '../service/locations/LocationAPI';
import { setupListeners } from '@reduxjs/toolkit/query';
import ZoneSettings from '../service/zoneSettings/ZoneSettingsAPI';
import TimerSettingsAPI from '../service/timerSettings/TimerSettingsAPI';
import { setExternalStore } from './StoreExternal';
import postRehydrate from './middleware/postRehydrate';
import ScheduleAPI from '../service/schedule/ScheduleAPI';
import StoreAPI from '../service/store/StoreAPI';
import WorkspaceAPI from './workspace/WorkspaceAPI';
import AlarmAPI from './alarm/AlarmAPI';
import UserAPI from './user/UserAPI';
import RightsApi from './rights/RightsAPI';
import ReportAPI from './reports/ReportAPI';
import ControlUnitAPI from './controlUnit/ControlUnitAPI';
import AuthAPI from '../service/auth/AuthAPI';
import DeviceChangePasswordAPI from '../service/deviceChangePassword/DeviceChangePasswordAPI';

// Fixes "Cannot assign to read only property" error message
// when modifying objects from Redux state directly.
// it is only for compatible production bundle meanwhile whe fix all mutation errors
// https://github.com/reduxjs/redux-toolkit/issues/424
if (process.env.NODE_ENV === 'production') {
  setAutoFreeze(false);
}

const persistConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['apiProductSlice'],
  whitelist: [
    'operator-store',
    'auth',
    'authManager',
    'features',
    'featureToggle',
  ],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: true,
    }).concat(
      postRehydrate,
      AlarmAPI.middleware,
      LocationAPI.middleware,
      ZoneSettings.middleware,
      TimerSettingsAPI.middleware,
      ScheduleAPI.middleware,
      StoreAPI.middleware,
      UserAPI.middleware,
      WorkspaceAPI.middleware,
      ReportAPI.middleware,
      RightsApi.middleware,
      ControlUnitAPI.middleware,
      AuthAPI.middleware,
      DeviceChangePasswordAPI.middleware
    ),
  devTools: true,
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
export const persistor = persistStore(store);
setExternalStore(store);

export default store;
